module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-checkbox"
  }, [(_vm.template === 'edit' || typeof _vm.template === 'undefined') ? [_c('input', {
    ref: "input",
    class: 'o-checkbox__input qa-' + _vm.field.name + '__input',
    attrs: {
      "type": "checkbox",
      "disabled": _vm.field.readonly,
      "readonly": _vm.field.readonly
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.value
    },
    on: {
      "change": function($event) {
        return _vm.update($event.target)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "o-checkbox__label"
  }, [_vm._v(_vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')))])] : _vm._e(), _vm._v(" "), (_vm.template === 'detail') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n      " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n    ")]), _vm._v(" "), _c('input', {
    ref: "input",
    class: 'o-checkbox__input qa-' + _vm.field.name + '__input',
    attrs: {
      "type": "checkbox",
      "disabled": _vm.field.readonly,
      "readonly": _vm.field.readonly,
      "disabled": ""
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.value
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "o-checkbox__label"
  }, [_vm._v(_vm._s(_vm.field.label))])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6beabe47"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/fields/FieldBool.vue
// module id = 549
// module chunks = 1